import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CmsEditorialArticle, CmsTaxonomy } from '@fcom/core-api';

@Component({
  selector: 'fin-article-bluewings',
  templateUrl: './article-bluewings.component.html',
  styleUrls: ['./article-bluewings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleBluewingsComponent {
  @Input()
  content: CmsEditorialArticle;

  readonly CmsTaxonomy = CmsTaxonomy;
}
